import { postAPI } from "../api/callAPI";
import { buildConfirmBody } from "../services/booking/buildConfirmBody";
import { payWithGateway } from "../services/paymentGateway";

export function needsBookingPayment(prepareData) {
  if (!prepareData) return false;
  if (prepareData.next_action === "DIRECT_CONFIRM") return false;

  return Boolean(
    prepareData.requires_payment ||
      prepareData.requires_security_deposit ||
      prepareData.next_action === "SECURITY_DEPOSIT_AUTH" ||
      prepareData.next_action === "FLASH_OFFER_PAYMENT"
  );
}

export function isDirectConfirm(prepareData) {
  return prepareData?.next_action === "DIRECT_CONFIRM";
}

function getAuthHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

function isAlreadyConfirmedError(message) {
  return (message || "").toLowerCase().includes("booking already confirmed");
}

export async function prepareUnifiedBooking(
  endpoint,
  token,
  booking,
  idempotencyKey,
  extraFields = {}
) {
  const partySize =
    (Number(booking.adult) || 0) +
    (Number(booking.child) || 0) +
    (Number(booking.infants) || 0);

  const resp = await postAPI(
    endpoint,
    "bookings/unified/prepare",
    {
      idempotency_key: idempotencyKey,
      ...booking,
      party_size: partySize,
      booking_context: { platform: "web" },
      ...extraFields,
    },
    { headers: getAuthHeaders(token) }
  );

  if (!resp?.success) {
    throw new Error(resp?.message || "Failed to prepare booking");
  }

  return resp.data;
}

export async function confirmUnifiedBooking(
  endpoint,
  token,
  idempotencyKey,
  booking,
  gateway,
  paymentResult
) {
  const confirmBody = buildConfirmBody(
    idempotencyKey,
    booking,
    gateway,
    paymentResult
  );

  const resp = await postAPI(endpoint, "bookings/unified/confirm", confirmBody, {
    headers: getAuthHeaders(token),
  });

  if (!resp?.success) {
    if (isAlreadyConfirmedError(resp?.message)) {
      return resp.data || { booking_id: null };
    }
    throw new Error(resp?.message || "Failed to confirm booking");
  }

  return resp.data;
}

export async function payWithGatewayForBooking(gateway, stripeOpts) {
  return payWithGateway(gateway, stripeOpts);
}
